/*
 * @Author: WUJUN
 * @Date: 2019-07-09 11:52:34
 * @LastEditTime: 2019-11-11 10:14:39
 * @LastEditors: WUJUN
 * @Description: 
 */
import request from "../utils/request";

// =========公共接口
// 登录
export const login = params => {
  return request.post(`/gf/web/pp/login.do`, params);
};
export const userInfo = params => {
  return request.post(`/web/account/info`, params);
};
export const pageView = params => {
  return request.post(`/clubpoints/report/pageview`, params);
};





// WEBPACK FOOTER //
// src/api/common.js